import { COMPUTER_TASKS_HREF } from '#pplx/frontend/apps/ask/layout/sidebar/core/shared/constants.js';
/**
 * Resolve row selection using the caller's direct-match override and inline child visibility.
 * Hidden descendant routes may select a parent even when direct matching is disabled;
 * a meta parent with visible inline children remains unselected.
 *
 * @param item - Destination, direct-match override, and native parent/child selection rules.
 * @param pathname - Current app path, or null when the router has no current path.
 * @param showChildren - Whether inline children are visible; collapsed popovers do not count.
 * @returns Whether the row should display its selected state.
 */
export function resolveSidebarNavigationSelection(item, pathname, showChildren = false) {
    const isCurrentPath = item.selected ??
        (pathname === item.href || (item.href === COMPUTER_TASKS_HREF && pathname === '/computer'));
    const isSelectedFromHiddenChild = !showChildren && (item.isChildRouteSelected?.(pathname) ?? false);
    return item.meta && showChildren ? false : isCurrentPath || isSelectedFromHiddenChild;
}
//# sourceMappingURL=resolveSidebarNavigationSelection.js.map